import React from 'react';
import { useTranslation } from 'react-i18next';

interface ToastProps {
  message: string;
  variant?: 'success' | 'error' | 'info';
  onClose?: () => void;
}

const Toast: React.FC<ToastProps> = ({ message, variant = 'info', onClose }) => {
  const { t } = useTranslation();
  const variantColors: Record<string, string> = {
    success: '#dcfce7',
    error: '#fee2e2',
    info: '#e0f2fe',
  };

  const variantBorder: Record<string, string> = {
    success: '2px solid #22c55e',
    error: '2px solid #ef4444',
    info: '2px solid #38bdf8',
  };

  return (
    <div className="toast" role="status" aria-live="polite" style={{ background: variantColors[variant], border: variantBorder[variant] }}>
      <p style={{ margin: 0, color: '#0f172a', fontWeight: 600 }}>{message}</p>
      {onClose ? (
        <button type="button" onClick={onClose} aria-label={t('toast.dismissNotification', 'Dismiss notification')} style={{ background: 'transparent', border: 'none', fontWeight: 700, cursor: 'pointer', color: '#0f172a' }}>
          ×
        </button>
      ) : null}
    </div>
  );
};

export default Toast;
